import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PartnerService } from '../../../services/partner.service';
import { CyclistService } from '../../../services/cyclist.service';
import { UserService } from '../../../services/user.service';
import { ServiceRequestService } from '../../../services/servicerequest.service';
import { ServiceTypeService } from '../../../services/service-type.service';
import { HelpersService } from '../../../services/helpers.service';
import { CouponsService } from '../../../services/coupons.service';
import { ChecklistService } from '../../../services/checklist.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AnalyticsService } from '../../../services/analytics.service';
import { JoyrideService } from 'ngx-joyride';
import { Observable, Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { MultiSelect } from 'primeng/multiselect';
import { CollectionsService } from '../../../services/collections.service';
import moment from 'moment';
import { ThirdPartyService } from '../../../services/thirdparty.service';

@Component({
  selector: 'app-schedule-service',
  templateUrl: './schedule-service.component.html',
  styleUrls: ['./schedule-service.component.scss'],
  providers: [MessageService],
})
export class ScheduleServiceComponent implements OnInit {
  @Input() partnerId;
  @Input() selectedTimeSlot;
  @Input() technician;
  @Input() fromCalendar;
  @Input() rentalBooking;
  @Input() rentalCustomer;
  @Input() rentalBike = false;
  public jobCardNo: string;
  public selectedServiceTypes: any = [];

  public availableDates: any = [];
  public serviceTypes: any = [];

  public showThirdParties: boolean = false;
  public thirdParties: any = [];
  public selectedThirdParty: any = null;
  public selectedThirdPartyIsResponsibileForPayment: boolean = false;

  public preServiceChecklist: any = [];
  public selectedDate: string;
  public bookedDate;
  public requiredBy;
  public bookingDateChanged: boolean = false;
  public defaultRequiredByDate;
  public search: string = '';
  public cyclists: any = [];
  public selectedCyclist: any = {};
  public bikes: any = null;
  public selectedBike: any = {};
  public step: number = 1;
  public customerNotes: string = '';
  public submitting: boolean = false;
  public searching: boolean = false;
  public addNewCyclist: boolean = false;
  public eventID: any;
  public walkinName = '';
  public partner: any = {};
  public walkInBusy: boolean = false;
  public isBikeHere: boolean = true;
  public sendCommunication: boolean = true;

  public isWalkIn: boolean = false;
  public couponCode = '';
  public couponCodeValid = false;
  public couponError = '';
  public editingCouponCode: boolean = false;
  public bikeBay = '';
  public countryData: any = {};
  public createdBy: number = 0;
  public preapprovedAmount: number = 0.0;
  public addressSearch: string = '';

  public collectionsConfigured = false;
  public allowCollection: boolean = false;
  public allowDelivery: boolean = false;
  public collection: any = {};
  public delivery: any = {};
  public addressOptions: any = [];
  public collectionAddrssLoading: boolean = false;
  public deliveryAddrssLoading: boolean = false;
  public availableCollectionDates: any = [];
  public unavailableCollectionDates: any = [];
  public collectionTimeSlots: any = [];
  public systemUsers: any = [];
  public technicians: any = [];
  public minDate = new Date();
  public maxDate = new Date();

  public newWalkInName: string = '';
  public newWalkInPhone: string = '';
  public newWalkInEmail: string = '';

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 250;

  public consentForMarketing: boolean = false;
  public showGDPRMarketingConsent: boolean = false;
  public userGaveGDPRMarketingConsent: boolean = false;
  public hasCustomQuestions: boolean = false;
  public serviceTypeQuestions: any = [];
  public loadingCustomQuestions: boolean = false;

  @ViewChild('serviceTypeDropDown') serviceTypeDropDown: MultiSelect;

  constructor(
    public modal: NgbActiveModal,
    public partnerService: PartnerService,
    public cyclistService: CyclistService,
    public serviceRequest: ServiceRequestService,
    public analyticsService: AnalyticsService,
    public datePipe: DatePipe,
    private translate: TranslateService,
    public messageService: MessageService,
    private helpersService: HelpersService,
    private userService: UserService,
    private joyrideService: JoyrideService,
    private couponsService: CouponsService,
    private checklistService: ChecklistService,
    private collectionsService: CollectionsService,
    private thirdPartyService: ThirdPartyService,
    private serviceTypeService: ServiceTypeService,
  ) {}

  inputChanged() {
    this.modelChanged.next(null);
  }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();

    this.partnerId = this.partner.ID;
    this.showGDPRMarketingConsent = this.partner.ShowGDPRMarketingConsent;

    this.collectionsConfigured =
      this.partner.OffersCollections && !this.rentalBike;
    this.countryData = this.helpersService.getCountryData();
    let dateTime = new Date();
    this.eventID = dateTime.getTime().toString();

    this.analyticsService
      .SendTimings(
        this.partnerId,
        this.eventID,
        'Schedule Service',
        'Open schedule service',
        '',
      )
      .subscribe((result) => {});

    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.checkCouponCode();
      });

    this.submitting = false;
    this.selectedServiceTypes = [];
    if (this.fromCalendar) {
      this.selectedDate = moment
        .utc(this.selectedTimeSlot)
        .format('YYYY-MM-DDTHH:mm');
      this.bookedDate = new Date(
        moment.utc(this.selectedDate).format('YYYY-MM-DDTHH:mm'),
      );
    } else {
      this.selectedDate = null;
    }
    this.checkHasCustomQuestions();
    this.getServiceTypes();
    this.getThirdParties();
    this.partnerService
      .getNextJobcardID(this.partnerId)
      .subscribe((jobCardNo) => {
        this.jobCardNo = jobCardNo;
      });
    if (this.selectedTimeSlot) {
      this.defaultRequiredByDate = new Date(
        moment(this.selectedDate).add(1, 'day').format('YYYY-MM-DDTHH:mm'),
      );
    }
    this.isBikeHere = this.partner.BikeIsHereDefault;

    this.walkinName = this.partner.Name;

    //if (this.helpersService.showTour('Cyclist')) {
    //  this.joyrideService.startTour({
    //    steps: ['sheduleStepOne'],
    //    showCounter: false,
    //    themeColor: '#151A2A',
    //  });
    //}

    this.getPreServiceChecklist();
    this.initializeCollection();

    this.getSystemUsers();
    if (this.rentalBooking) {
      this.setupRental();
    }

  }

  getAvailableSlots(technicianSpecific = false){
    if(!this.fromCalendar){
      this.serviceRequest.getWorkshopAvailability(this.partnerId,moment().format("YYYY-MM-DDTHH:mm:ss"), moment().add(1, 'month').format("YYYY-MM-DD"), this.selectedServiceTypes, technicianSpecific && this.technician && this.technician > 0 ? this.technician : '').subscribe(result=>{
        if(result && result.length > 0){
          this.selectedTimeSlot = result[0].Date + "T" + result[0].StartTime;
          this.technician = result[0].TechnicianID;
          this.selectedDate = moment.utc(this.selectedTimeSlot).format('YYYY-MM-DDTHH:mm');
          this.bookedDate = new Date(moment.utc(this.selectedDate).format('YYYY-MM-DDTHH:mm'));

          if(!technicianSpecific){
            this.technicians = this.technicians.map(x=>{
              console.log(x.id + " => " + x.name + " => "+ result.filter(y=>{ return y.TechnicianID == x.id }).length)
              return {...x, disabled: result.filter(y=>{
                return y.TechnicianID == x.id
              }).length == 0}
            })
          }

        }
      });
    }
  }

  getThirdParties() {
    this.thirdPartyService
      .getThirdParties(this.partnerId)
      .subscribe((result) => {
        this.thirdParties = result.map((item) => {
          return {
            label: item.name,
            value: item.id,
            disabled: false,
          };
        });

        if (this.thirdParties.length > 0) {
          this.showThirdParties = true;
        } else {
          this.showThirdParties = false;
        }

        this.thirdParties.splice(0, 0, {
          label: 'None',
          value: null,
          disabled: false,
        });

        this.selectedThirdParty = null;
      });
  }

  setupRental() {
    this.selectedCyclist = this.rentalCustomer;
    this.selectedBike = this.rentalBike;
    this.isBikeHere = true;
    this.sendCommunication = false;
    this.step = 2;
  }

  checkHasCustomQuestions() {
    this.serviceTypeService
      .getWorkshopCustomQuestions(this.partnerId)
      .subscribe((res) => {
        this.hasCustomQuestions = res && res.length > 0;
      });
  }

  getServiceTypeQuestions() {
    this.loadingCustomQuestions = true;
    var serviceTypeIDs = this.selectedServiceTypes.join(',');
    this.serviceTypeService
      .getServiceTypesCustomQuestions(this.partnerId, serviceTypeIDs)
      .subscribe(
        (res) => {
          this.serviceTypeQuestions = res;
          this.loadingCustomQuestions = false;
        },
        (err) => {
          this.loadingCustomQuestions = false;
        },
      );
  }

  tourCyclistDone() {
    this.helpersService.tourComplete('Cyclist');
  }

  tourServiceTypesDone() {
    this.helpersService.tourComplete('ServiceTypes');
  }

  next() {
    this.step = this.step + 1;

    //If store not configured for collection, skip to next step
    //if ((this.isBikeHere || !this.collectionsConfigured || this.partner.PartnerType !== 1) && this.step === 3) {
    if (!this.hasCustomQuestions && this.step == 3) {
      this.step = this.step + 1;
    }
    if ((this.isBikeHere || !this.collectionsConfigured) && this.step === 4) {
      this.step = this.step + 1;
    }
    if (this.step == 3 && this.hasCustomQuestions) {
      this.getServiceTypeQuestions();
    }
    if (this.step === 1)
      this.analyticsService
        .SendTimings(
          this.partnerId,
          this.eventID,
          'Schedule Service',
          'Select cyclist info',
          '',
        )
        .subscribe((result) => {});
    if (this.step === 2) {
      this.analyticsService
        .SendTimings(
          this.partnerId,
          this.eventID,
          'Schedule Service',
          'Select service types',
          '',
        )
        .subscribe((result) => {});
      //if (this.helpersService.showTour('ServiceTypes')) {
      //  this.joyrideService.startTour({
      //    steps: ['sheduleStepTwo'],
      //    showCounter: false,
      //    themeColor: '#151A2A',
      //  });
      //}
    }
    if (this.step === 5)
      this.analyticsService
        .SendTimings(
          this.partnerId,
          this.eventID,
          'Schedule Service',
          'Add client notes',
          '',
        )
        .subscribe((result) => {});
  }

  back() {
    this.step = this.step - 1;
    //if ((this.isBikeHere || !this.collectionsConfigured || this.partner.PartnerType !== 1) && this.step === 3) {
    if ((this.isBikeHere || !this.collectionsConfigured) && this.step === 4) {
      this.step = this.step - 1;
    }
    if (!this.hasCustomQuestions && this.step == 3) {
      this.step = this.step - 1;
    }
    if (this.step === 1)
      this.analyticsService
        .SendTimings(
          this.partnerId,
          this.eventID,
          'Schedule Service',
          'Select cyclist info',
          '',
        )
        .subscribe((result) => {});
    if (this.step === 2)
      this.analyticsService
        .SendTimings(
          this.partnerId,
          this.eventID,
          'Schedule Service',
          'Select service types',
          '',
        )
        .subscribe((result) => {});
    if (this.step === 4)
      this.analyticsService
        .SendTimings(
          this.partnerId,
          this.eventID,
          'Schedule Service',
          'Add client notes',
          '',
        )
        .subscribe((result) => {});
  }

  getServiceTypes() {
    this.serviceTypes = [];
    this.partnerService
      .getPartnerServiceTypesDropDowns(this.partnerId)
      .subscribe((serviceTypes) => {
        var GroupName = '';
        serviceTypes
          .filter((serviceType) => {
            return serviceType.IsActive;
          })
          .sort((x, y) => {
            return x.GroupOrder - y.GroupOrder || x.GroupName - y.GroupName;
          })
          .map((serviceType) => {
            serviceType.GroupName = serviceType.GroupName
              ? serviceType.GroupName
              : this.translate.instant('general.not_grouped');
            if (serviceType.GroupName !== GroupName) {
              GroupName = serviceType.GroupName;
              this.serviceTypes.push({
                label: serviceType.GroupName,
                value: -1,
                disabled: true,
                search: '',
                reverseSearch: '',
              });
            }
            var words = serviceType.ServiceTypeDescription.split(' ');
            var reverseSearch = [];
            if (words) {
              words.forEach((word) => {
                reverseSearch.unshift(word);
              });
            }
            this.serviceTypes.push({
              label:
                serviceType.ServiceTypeDescription +
                ' - ' +
                this.partner.CurrencySymbol +
                serviceType.Cost,
              value: serviceType.ID,
              disabled: false,
              hours: serviceType.Hours,
              cost: serviceType.Cost,
              search: serviceType.ServiceTypeDescription,
              reverseSearch: reverseSearch.join(' '),
            });
          });

        //this.performThirdPartyFromServiceTypeSelected();
      });
  }

  getSystemUsers() {
    this.partnerService
      .getPartnerSystemUsers(this.partnerId)
      .subscribe((users) => {
        this.systemUsers = users.map((x) => {
          return {
            value: x.ID,
            label: x.Name ? x.Name + ' ' + x.Surname : x.Email,
          };
        });
        if (
          this.systemUsers
            .map((x) => {
              return x.value;
            })
            .indexOf(this.helpersService.getProfileData().ID) > -1
        ) {
          this.createdBy = this.helpersService.getProfileData().ID;
        }

        this.technicians = users.filter(user=>{
          return user.UserRoles.some(role => role.RoleID === 1 || role.RoleID === 4)
        }).map((x) => {
          return {
            id: x.TechnicianID,
            name: x.Name,
          };
        });

        if(this.selectedTimeSlot == null && this.technician == null){
          this.getAvailableSlots();
        }
      });
  }

  getPreServiceChecklist() {
    this.checklistService
      .getPreServiceChecklist(this.partnerId)
      .subscribe((checklist) => {
        this.preServiceChecklist = checklist;
      });
  }

  // performThirdPartyFromServiceTypeSelected(){
  //   // Check if any selected item has hasPartnerServiceType set to true
  //   if(this.selectedServiceTypes.length)
  //   {
  //     //Has items selected
  //     this.selectedServiceTypeLinkedToThirdParty = this.selectedServiceTypes.some(selectedValue => {
  //       //Get item selected details
  //       const selectedItem = this.serviceTypes.find(item => item.value === selectedValue);

  //       //Check if item selected is linked to third party
  //       if(selectedItem && selectedItem.hasPartnerServiceType === true)
  //       {
  //         //Only enable third parties of same type
  //         this.selectedServiceTypeThirdPartyName = selectedItem.thirdPartyName;
  //         this.serviceTypes.forEach(item => {
  //           if (item.thirdPartyName !== selectedItem.thirdPartyName) {
  //             item.disabled = true;
  //           }
  //           else if(item.value == -1)
  //           {
  //             item.disabled = true;
  //           }
  //           else{
  //             item.disabled = false;
  //           }
  //         });
  //         return true;
  //       }
  //       else{
  //         //Item selected is not linked to third party
  //         this.selectedServiceTypeThirdPartyName = "";
  //         this.serviceTypes.forEach(item => {
  //           if(item.value == -1 || item.thirdPartyName.length > 0)
  //           {
  //             item.disabled = true;
  //           }
  //           else{
  //             item.disabled = false;
  //           }
  //         });
  //         return false;
  //       }
  //     });
  //   }
  //   else{
  //     //No items selected
  //     this.selectedServiceTypeThirdPartyName = "";
  //     this.selectedServiceTypeLinkedToThirdParty = false;
  //     this.serviceTypes.forEach(item => {
  //       if(item.value == -1)
  //       {
  //         item.disabled = true;
  //       }
  //       else{
  //         item.disabled = false;
  //       }
  //     });
  //   }
  // }

  getNextAvailableDates() {
    //this.performThirdPartyFromServiceTypeSelected();

    if (!this.fromCalendar) {
      this.partnerService
        .getNextAvailableDatesForService(
          this.partnerId,
          this.selectedServiceTypes,
        )
        .subscribe((dates) => {
          this.availableDates = [];
          dates.forEach((date) => {
            var formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd');
            this.availableDates.push({
              label: formattedDate,
              value: formattedDate,
            });
          });
          if (this.availableDates.length > 0) {
            this.selectedDate = this.availableDates[0].value;
          }
        });
    }

    this.serviceTypeDropDown.filterValue = '';
  }

  searchCyclist() {
    this.isWalkIn = false;
    this.cyclists = null;
    this.selectedCyclist = {};
    this.selectedBike = {};
    this.searching = true;
    this.addNewCyclist = false;
    this.cyclistService
      .searchCyclist(this.partnerId, this.search)
      .subscribe((cyclists) => {
        this.cyclists = [];
        cyclists.forEach((cyclist) => {
          this.cyclists.push({
            label:
              cyclist.Name + ' ' + cyclist.Surname + ' (' + cyclist.Email + ')',
            value: cyclist,
          });
        });
        if (this.cyclists.length > 0) {
          this.selectedCyclist = this.cyclists[0].value;
          this.getBikes();
        } else {
          this.selectedBike = {};
          this.bikes = [];
          this.searching = false;
        }

        this.analyticsService
          .SendTimings(
            this.partnerId,
            this.eventID,
            'Schedule Service',
            'Search Cyclist',
            '',
          )
          .subscribe((result) => {});
      });
  }

  getBikes() {
    this.selectedBike = {};
    this.cyclistService
      .getActiveBikesForCyclistAndPartner(
        this.selectedCyclist.ID,
        this.partner.ID,
      )
      .subscribe((bikes) => {
        this.searching = false;
        this.bikes = [];
        bikes.forEach((bike) => {
          this.bikes.push({
            label: bike.Manufacturer + ' ' + bike.Model,
            value: bike,
          });
        });
        if (this.bikes.length > 0) {
          this.selectedBike = this.bikes[0].value;
        }
      });
  }

  changeServiceDate() {
    this.bookingDateChanged = true;
    this.selectedDate = moment(this.bookedDate).format('YYYY-MM-DDTHH:mm:ss');
  }

  scheduleBooking(openBooking = false) {
    this.submitting = true;
    var body = {
      ID: this.partnerId,
      BikeID: this.selectedBike.ID,
      ServiceTypes: this.selectedServiceTypes,
      ServiceDate: this.selectedDate,
      RequiredByDate: null,
      PleaseBookIn: true,
      NewJobcardID: this.jobCardNo,
      Notes: this.customerNotes,
      TechnicianID:
        this.technician && this.technician.id > 0
          ? parseInt(this.technician.id)
          : this.technician > 0 ? this.technician : 0,
      isBikeHere: this.isBikeHere,
      CouponCode:
        this.couponCodeValid && this.couponCode && this.couponCode.length > 0
          ? this.couponCode
          : '',
      PreServiceChecklist: this.preServiceChecklist,
      BikeBay: this.bikeBay,
      CreatedBy: this.createdBy ? this.createdBy : null,
      IsCollection: false,
      IsDelivery: false,
      CollectionInfo: null,
      DeliveryInfo: null,
      PreApprovedAmount: this.preapprovedAmount,
      SelectedThirdParty: this.selectedThirdParty,
      SelectedThirdPartyIsResponsibileForPayment:
        this.selectedThirdPartyIsResponsibileForPayment,
      ServiceTypeQuestions: this.serviceTypeQuestions,
    };
    if (this.requiredBy) {
      body.RequiredByDate = moment(this.requiredBy).format('YYYY-MM-DDTHH:mm');
    }
    if (this.allowCollection) {
      body = {
        ...body,
        ...{
          IsCollection: this.allowCollection,
          CollectionInfo:
            this.allowCollection &&
            this.collection &&
            this.collection.scheduleDate
              ? {
                  ScheduleDate: moment(this.collection.scheduleDate).format(
                    'YYYY-MM-DD',
                  ),
                  FullAddress: this.collection.fullAddress.address,
                  AddressDetails: this.collection.addressDetails,
                  TimeSlot: {
                    deliveryVehicleID:
                      this.collection.timeSlot.deliveryVehicleID,
                    slotStartTime: this.collection.timeSlot.slotStartTime,
                    slotEndTime: this.collection.timeSlot.slotEndTime,
                  },
                  CollectionFee: this.collection.collectionFee,
                  DeliveryFee: this.collection.deliveryFee,
                  Notes: this.collection.notes,
                }
              : null,
        },
      };
      if (this.collection.updatedBookingDate) {
        body.ServiceDate = this.collection.updatedBookingDate;
      }
    }
    if (this.allowDelivery) {
      body = { ...body, IsDelivery: this.allowDelivery };
      if (
        this.delivery &&
        this.delivery.fullAddress &&
        this.delivery.fullAddress.address
      ) {
        body = {
          ...body,
          DeliveryInfo: {
            FullAddress: this.delivery.fullAddress.address,
            AddressDetails: this.delivery.addressDetails,
            CollectionFee: this.delivery.collectionFee,
            DeliveryFee: this.delivery.deliveryFee,
            Notes: this.delivery.notes,
          },
        };
      }
    }

    this.partnerService.scheduleService(body, this.sendCommunication).subscribe(
      (jobcard) => {
        this.analyticsService
          .SendTimings(
            this.partnerId,
            this.eventID,
            'Schedule Service',
            'Schedule',
            JSON.stringify(body),
          )
          .subscribe((result) => {});

        if (body.TechnicianID > 0 && this.isBikeHere) {
          this.serviceRequest
            .assignToTechnician(
              jobcard.ID,
              body.TechnicianID,
              this.sendCommunication,
            )
            .subscribe(
              (techresult) => {
                this.submitting = false;
                this.modal.close({
                  jobcard: techresult,
                  message: this.translate.instant(
                    'bikeshop.modal.shedule_service.message_bike_booked_in',
                    { JobCardNo: jobcard.JobCardNo },
                  ),
                  bookingDateChanged: this.bookingDateChanged,
                  openBooking: openBooking,
                });
              },
              (error) => {
                //Try assign to technician again
                this.serviceRequest
                  .assignToTechnician(
                    jobcard.ID,
                    body.TechnicianID,
                    this.sendCommunication,
                  )
                  .subscribe((techresult) => {
                    this.submitting = false;
                    this.modal.close({
                      jobcard: techresult,
                      message: this.translate.instant(
                        'bikeshop.modal.shedule_service.message_bike_booked_in',
                        { JobCardNo: jobcard.JobCardNo },
                      ),
                      bookingDateChanged: this.bookingDateChanged,
                      openBooking: openBooking,
                    });
                  });
              },
            );
        } else {
          this.submitting = false;
          this.modal.close({
            jobcard,
            message: this.translate.instant(
              'bikeshop.modal.shedule_service.message_bike_booked_in',
              { JobCardNo: jobcard.JobCardNo },
            ),
            bookingDateChanged: this.bookingDateChanged,
            openBooking: openBooking,
          });
          this.partnerService
            .getNextJobcardID(this.partnerId)
            .subscribe((jobCardNo) => {
              this.jobCardNo = jobCardNo;
            });
        }
      },
      (error) => {
        this.submitting = false;
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant(
            'bikeshop.modal.shedule_service.error_scheduling_service',
          ),
        });
        this.partnerService
          .getNextJobcardID(this.partnerId)
          .subscribe((jobCardNo) => {
            this.jobCardNo = jobCardNo;
          });
      },
    );
  }

  scheduleBookingAndOpen() {
    this.scheduleBooking(true);
  }

  addCyclist() {
    this.selectedCyclist = {};
    this.selectedBike = {};
    this.cyclists = null;
    this.bikes = null;

    setTimeout(() => {
      this.cyclists = [];
      this.bikes = [];
      this.addNewCyclist = true;
      this.searching = false;
    }, 1000);
  }

  newCyclist(event) {
    if (event.searchAgain) {
      this.search =
        event.cyclist.Email && event.cyclist.Email.length > 0
          ? event.cyclist.Email
          : event.cyclist.PhoneNumber;
      this.searchCyclist();
    } else {
      this.selectedBike = event.bike;
      this.selectedCyclist = event.cyclist;
      if (this.selectedBike && this.selectedCyclist) {
        this.next();
      } else {
        this.search = event.cyclist.Email;
        this.searchCyclist();
      }
    }
  }

  bikeSelected(event) {
    this.selectedBike = event.bike;
    this.selectedCyclist = event.cyclist;
    this.userGaveGDPRMarketingConsent =
      this.selectedCyclist.GDPRMarketingConsentDate == null ? false : true;
    this.consentForMarketing = this.selectedCyclist.GDPRMarketingConsent;

    if (event.next) {
      this.next();
    }
  }

  addBike() {
    this.selectedBike = {};
    this.bikes = [];
    this.addNewCyclist = true;
    this.searching = false;
  }

  createWalkin() {
    this.isWalkIn = true;
    this.walkInBusy = true;
    this.partnerService
      .getWalkin(
        this.partnerId,
        this.translate.instant('general.walkin'),
        this.newWalkInName,
        this.newWalkInPhone,
        this.newWalkInEmail,
      )
      .subscribe(
        (bikes) => {
          if (bikes.length == 1) {
            this.selectedBike = bikes[0];
            this.walkInBusy = false;
            this.next();
          } else {
            this.selectedBike = {};
            this.cyclistService
              .getActiveBikesForCyclistAndPartner(
                bikes[0].UserID,
                this.partner.ID,
              )
              .subscribe((bikes) => {
                this.searching = false;
                this.bikes = [];
                alert('3.');
                bikes.forEach((bike) => {
                  this.bikes.push({
                    label: bike.Manufacturer + ' ' + bike.Model,
                    value: bike,
                  });
                });
                if (this.bikes.length > 0) {
                  this.selectedBike = this.bikes[0].value;
                }
              });
          }

          //for (var i = 0; i < obj.ClaimStatus.length; i++) {
          //}

          //this.selectedBike = bike;
          //this.walkInBusy = false;
          //this.next();
        },
        (error) => {
          this.walkInBusy = false;
        },
      );
  }

  checkCouponCode() {
    if (this.couponCode && this.couponCode.length > 0) {
      var data = {
        PartnerID: this.partnerId,
        CouponCode: this.couponCode,
        UserID: this.selectedCyclist.ID,
        SelectedServiceTypes: this.selectedServiceTypes,
      };
      this.couponsService.validateCouponCode(data).subscribe(
        (res) => {
          this.couponCodeValid = true;
        },
        (err) => {
          if (
            err.error.message !==
            'bikeshop.modal.update_job_card.job_card.coupon_code_not_found'
          ) {
            this.couponCodeValid = false;
            this.couponError = this.translate.instant(err.error.message);
          }
        },
      );
    }
  }

  /*Collections*/

  initializeCollection() {
    this.minDate = new Date();
    this.maxDate = new Date(
      moment(this.minDate).add('year', 2).format('YYYY-MM-DD'),
    );

    var startDate = new Date(
      moment(this.minDate).add('year', -1).format('YYYY-MM-DD'),
    );
    var endDate = new Date(
      moment(this.minDate).add('year', 2).format('YYYY-MM-DD'),
    );
    while (startDate <= endDate) {
      var d = new Date(startDate);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      this.unavailableCollectionDates.push(d);
      startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    }
  }

  getAvailability(fromDate: string, reset = true) {
    if (this.collection.areaID) {
      const data = {
        PartnerID: this.partnerId,
        FromDate: moment(fromDate).add('days', -7).format('YYYY-MM-DD'),
        ToDate: moment(fromDate)
          .add('month', 2)
          .endOf('month')
          .format('YYYY-MM-DD'),
        CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        IsCollection: true,
        IsDelivery: false,
        AreaID: this.collection.areaID,
        ServiceTypes: this.selectedServiceTypes.join(','),
      };
      var invalidDates = JSON.parse(
        JSON.stringify(this.unavailableCollectionDates),
      );
      invalidDates = invalidDates.map((x) => {
        return new Date(x);
      });
      this.collectionsService.getCollectionsAvailability(data).subscribe(
        (response: any) => {
          if (response.availableDates && response.availableDates.length > 0) {
            this.availableCollectionDates = response.availableDates;

            response.availableDates.forEach((availableDate: any) => {
              var index = invalidDates
                .map((x) => {
                  return moment(x).format('YYYY-MM-DD');
                })
                .indexOf(
                  moment(availableDate.availableDate).format('YYYY-MM-DD'),
                );
              if (index > -1) {
                invalidDates.splice(index, 1);
              }
            });
            this.unavailableCollectionDates = invalidDates;

            if (!reset) {
              this.setBookingDate(reset);
            }
          }
          if (
            response.unavailableDates &&
            response.unavailableDates.length > 0
          ) {
            response.unavailableDates.map((x) => {
              var d = new Date(x.unavailableDate);
              d.setHours(0);
              d.setMinutes(0);
              d.setSeconds(0);
              d.setMilliseconds(0);
              var index = this.unavailableCollectionDates.findIndex((x) => {
                return x.valueOf() === d.valueOf();
              });
              if (index === -1) {
                this.unavailableCollectionDates.push(d);
              }
            });
          }
          this.collectionAddrssLoading = false;
        },
        (err) => {
          this.collectionAddrssLoading = false;
        },
      );
    } else {
      this.collectionAddrssLoading = false;
    }
  }

  validateCollection() {
    var collectionsValid =
      !this.allowCollection ||
      (this.allowCollection &&
        this.collection &&
        this.collection.scheduleDate &&
        this.collection.fullAddress &&
        this.collection.fullAddress.address &&
        this.collection.fullAddress.address &&
        this.collection.timeSlot);

    var deliveryValid =
      !this.allowDelivery ||
      (this.allowDelivery &&
        (!this.delivery.fullAddress || !this.delivery.fullAddress.address)) ||
      (this.allowDelivery &&
        this.delivery.fullAddress &&
        this.delivery.fullAddress.address &&
        !this.delivery.addressOutOfRange);

    return collectionsValid && deliveryValid;
  }

  selectTimeSlot(timeSlot) {
    this.collection.timeSlot = timeSlot.value;
  }

  setBookingDate(reset = false) {
    this.collection.updatedBookingDate = null;
    this.collectionTimeSlots = [];
    if (this.collection.scheduleDate) {
      if (reset) {
        this.collection.timeSlot = {};
      }

      var selectedDate = this.availableCollectionDates.filter((x) => {
        return (
          moment(x.availableDate).format('YYYY-MM-DD') ===
          moment(this.collection.scheduleDate).format('YYYY-MM-DD')
        );
      });
      if (selectedDate && selectedDate.length > 0) {
        this.collectionTimeSlots = selectedDate[0].slots.map((x, index) => {
          return { ...x, code: index + 1, name: x.label, value: x.label };
        });
        if (this.collectionTimeSlots.length == 1) {
          this.collection.timeSlot = this.collectionTimeSlots[0];
        } else if (
          this.collection &&
          this.collection.timeSlot &&
          this.collection.timeSlot.label
        ) {
          var index = this.collectionTimeSlots.findIndex((x) => {
            return x.label === this.collection.timeSlot.label;
          });
          if (index > -1) {
            this.collection.timeSlot = this.collectionTimeSlots[index];
          }
        }
      }
      if (this.scheduleDateLessThanCollection()) {
        this.collectionsService
          .getServiceAvailability(
            this.partnerId,
            moment(this.collection.scheduleDate).format('YYYY-MM-DD'),
            this.technician.id,
            this.selectedServiceTypes.join(','),
          )
          .subscribe((updatedDate) => {
            if (updatedDate && updatedDate.serviceDate) {
              this.collection.updatedBookingDate = updatedDate.serviceDate;
              this.technician.id = updatedDate.technicianID;
            }
          });
      }
    }
  }

  searchAddress(address) {
    this.addressSearch = address.query;
    this.collection.googlePlaceID = null;
    this.collectionsService
      .getAddressOptions(
        address.query,
        this.partner.Country === 'GB' && this.addressSearch.length <= 8
          ? 'GB'
          : `${this.partner.Latitude},${this.partner.Longitude}`,
      )
      .subscribe((res) => {
        this.addressOptions = res.predictions.map((x) => {
          return { address: x.description, placeID: x.place_id };
        });
      });
  }

  onSelectAddress(event, type) {
    if (type === 'COLLECTION') {
      this.collectionAddrssLoading = true;
      this.collection.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    } else {
      this.deliveryAddrssLoading = true;
      this.delivery.googlePlaceID = event.placeID;
      if (!event.placeID) {
        this.getAddressPlaceDetails(type, true);
      } else {
        this.getLocationFromAddress(event.address, type);
      }
    }
  }

  monthChanged(date) {
    this.collectionTimeSlots = [];

    var fromDate = moment(new Date(date.year, date.month - 1, 1))
      .startOf('month')
      .format('YYYY-MM-DD');
    this.getAvailability(fromDate, false);
  }

  async getAddressPlaceDetails(type, getLocFromAddress = false) {
    if (type === 'COLLECTION') {
      await this.collectionsService
        .getAddressOptions(
          this.collection.fullAddress.address,
          `${this.partner.Latitude},${this.partner.Longitude}`,
        )
        .subscribe((res) => {
          this.collection.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (getLocFromAddress && this.collection.googlePlaceID) {
            this.getLocationFromAddress(
              this.collection.fullAddress.address,
              type,
            );
          }
        });
    } else {
      await this.collectionsService
        .getAddressOptions(
          this.delivery.fullAddress.address,
          `${this.partner.Latitude},${this.partner.Longitude}`,
        )
        .subscribe((res) => {
          this.delivery.googlePlaceID =
            res.predictions && res.predictions.length > 0
              ? res.predictions[0].place_id
              : 'N/A';
          if (getLocFromAddress && this.delivery.googlePlaceID) {
            this.getLocationFromAddress(
              this.delivery.fullAddress.address,
              type,
            );
          }
        });
    }
  }

  getLocationFromAddress(address, type, reset = true) {
    this.collectionsService
      .getLocationFromAddress(
        address +
          (this.partner.Country === 'GB' && this.addressSearch.length <= 8
            ? ', ' + this.addressSearch + ', UK'
            : ''),
      )
      .subscribe((res) => {
        const data = {
          PartnerID: this.partnerId,
          IsCollection: type === 'COLLECTION',
          IsDelivery: type === 'DELIVERY',
          Latitude: res.lat,
          Longitude: res.lng,
          CurrentLocalTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        };
        if (type === 'COLLECTION') {
          if (!this.collection.googlePlaceID) {
            this.getAddressPlaceDetails(type, true);
            return;
          }

          this.collectionsService.checkAddressInRange(data).subscribe(
            (addressInfo: any) => {
              if (addressInfo && addressInfo.partnerID == this.partnerId) {
                this.collectionsService
                  .getGooglePlaceInfo(this.collection.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.collection.addressOutOfRange = false;
                this.collection.distanceToPartner = addressInfo.distanceToStore;
                this.collection.areaID = addressInfo.areaID;
                this.collection.collectionFee = addressInfo.collectionFee;
                this.collection.deliveryFee = addressInfo.deliveryFee;
                var fromDate = moment(
                  this.collection.scheduleDate || this.minDate,
                )
                  .startOf('month')
                  .format('YYYY-MM-DD');
                this.getAvailability(fromDate, reset);
              } else {
                this.collection.addressOutOfRange = true;
                this.collection.distanceToPartner = -1;
                this.collection.areaID = 0;
                this.collectionAddrssLoading = false;
                this.collection.scheduleDate = null;
                this.collection.timeSlot = null;
                this.collectionTimeSlots = [];
                this.collection.collectionFee = null;
                this.collection.deliveryFee = null;
              }
            },
            (err) => {
              this.collection.addressOutOfRange = true;
              this.collection.distanceToPartner = -1;
              this.collection.areaID = 0;
              this.collectionAddrssLoading = false;
              this.collection.scheduleDate = null;
              this.collection.timeSlot = null;
              this.collectionTimeSlots = [];
              this.collection.collectionFee = null;
              this.collection.deliveryFee = null;
            },
          );
        } else {
          if (!this.delivery.googlePlaceID) {
            this.getAddressPlaceDetails(type, true);
            return;
          }

          this.collectionsService.checkAddressInRange(data).subscribe(
            (addressInfo: any) => {
              if (addressInfo && addressInfo.partnerID == this.partnerId) {
                this.collectionsService
                  .getGooglePlaceInfo(this.delivery.googlePlaceID)
                  .subscribe((placeInfo) => {
                    this.setAddressInfo(placeInfo, type);
                  });
                this.delivery.addressOutOfRange = false;
                this.deliveryAddrssLoading = false;
                this.delivery.distanceToPartner = addressInfo.distanceToStore;
                this.delivery.areaID = addressInfo.areaID;
                this.delivery.collectionFee = addressInfo.collectionFee;
                this.delivery.deliveryFee = addressInfo.deliveryFee;
                //var fromDate = moment(this.delivery.scheduleDate || this.minDate).startOf('month').format("YYYY-MM-DD");
                //this.getAvailability(fromDate, reset);
              } else {
                this.delivery.addressOutOfRange = true;
                this.delivery.distanceToPartner = -1;
                this.delivery.areaID = 0;
                this.deliveryAddrssLoading = false;
                this.delivery.scheduleDate = null;
                this.delivery.timeSlot = null;
              }
            },
            (err) => {
              this.delivery.addressOutOfRange = true;
              this.delivery.distanceToPartner = -1;
              this.delivery.areaID = 0;
              this.deliveryAddrssLoading = false;
              this.delivery.scheduleDate = null;
              this.delivery.timeSlot = null;
            },
          );
        }
      });
  }

  setAddressInfo(placeInfo, type) {
    if (placeInfo) {
      var GooglePlace = JSON.parse(placeInfo).result;
      var addressDetails = {
        street_no: null,
        street_address: null,
        city: null,
        country: null,
        postal_code: null,
        latitude: null,
        longitude: null,
      };
      if (GooglePlace && GooglePlace.address_components) {
        var street_no = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('street_number') > -1;
          })
          .pop();
        if (street_no) {
          addressDetails.street_no = street_no.long_name;
        }
        var street_address = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('route') > -1;
          })
          .pop();
        if (street_address) {
          addressDetails.street_address = street_address.long_name;
        }
        var city = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_town') > -1;
          })
          .pop();
        if (city) {
          addressDetails.city = city.long_name;
        }
        if (!city) {
          var city = GooglePlace.address_components
            .filter((x) => {
              return x.types.indexOf('locality') > -1;
            })
            .pop();
          if (city) {
            addressDetails.city = city.long_name;
          }
        }

        var country = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('country') > -1;
          })
          .pop();
        if (country) {
          addressDetails.country = country.long_name;
        }
        var postal_code = GooglePlace.address_components
          .filter((x) => {
            return x.types.indexOf('postal_code') > -1;
          })
          .pop();
        if (postal_code) {
          addressDetails.postal_code = postal_code.long_name;
        }
        addressDetails.latitude = GooglePlace.geometry.location.lat;
        addressDetails.longitude = GooglePlace.geometry.location.lng;
        if (type === 'COLLECTION') {
          this.collection.addressDetails = addressDetails;
        } else {
          this.delivery.addressDetails = addressDetails;
        }
      }
    }
  }

  scheduleDateLessThanCollection() {
    return (
      moment(this.collection.scheduleDate).startOf('day') >=
      moment(this.selectedDate).startOf('day')
    );
  }

  getFriendlyBookingDate() {
    return moment(this.collection.updatedBookingDate).format(
      this.countryData.MomentDateFormat,
    );
  }

  hasMandatoryQuestion(serviceType) {
    if (serviceType.customQuestions) {
      return (
        serviceType.customQuestions.filter((x) => {
          return x.mandatory && !x.response;
        }).length > 0
      );
    } else {
      return false;
    }
  }

  mandatoryCustomQuestionsCompleted() {
    var formComplete = this.loadingCustomQuestions ? false : true;
    if (
      this.serviceTypeQuestions &&
      this.serviceTypeQuestions.length > 0 &&
      !this.loadingCustomQuestions
    ) {
      this.serviceTypeQuestions.forEach((serviceType) => {
        console.log(
          serviceType.customQuestions.filter((question) => {
            return question.mandatory && !question.response;
          }).length,
        );
        if (
          serviceType.customQuestions &&
          serviceType.customQuestions.length > 0 &&
          serviceType.customQuestions.filter((question) => {
            return question.mandatory && !question.response;
          }).length > 0
        ) {
          formComplete = false;
        }
      });
    }
    return formComplete;
  }

  updateChecklistItem(item) {
    //console.log(item);
    //console.log(this.preServiceChecklist);
    this.preServiceChecklist.find(x => x.id == item.id).rearValue = item.rearValue ?? '';
    this.preServiceChecklist.find(x => x.id == item.id).frontValue = item.frontValue ?? '';
    this.preServiceChecklist.find(x => x.id == item.id).defaultValue = item.defaultValue ?? '';
    //console.log(this.preServiceChecklist);
  }
}
